import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #000",
    paddingBottom: "1em",
    margin: "15px 0px 15px 0px",
  },
  avatar: {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    display: "inline-block",
    verticalAlign: "middle",
    /*marginRight: "9px",*/
    border: "2px solid #fff",
  },
  name: {
    fontSize: "16px",
    marginBottom: "5px",
    color: "black",
    marginTop: "4px",
    float: "left",
  },
  role: {
    fontSize: "14px",
    color: "#76787a",
  },
  labels: {
    fontSize: "14px",
    color: "black",
    marginLeft: "3%",
    textTransform: "uppercase"
  },
  valueLabels: {
    fontSize: "14px",
    marginLeft: "0.8em",
  },
  profileDiv: {
    minHeight: "10px !important",
    maxHeight: "40px !important",
  },
});

export default styles;
